import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useTheme} from 'styled-components';
import {getMainColor} from 'styled/common';
import {useShareButtonStore} from './useShareButtonStore';
import ModalSheet from 'components/common/ModalSheet';
import ShareRegistrationLink from 'components/ModalSheets/ShareRegistrationLink';
import {ShareBtnContainer, ShareText} from './styled';
import {CornerUpRight} from 'lucide-react';
import {useLayoutMode} from 'hooks/useLayoutMode';

function ShareButton() {
  const theme = useTheme();
  const {t} = useTranslation();
  const {isModalOpen, openModal, closeModal} = useShareButtonStore();
  const layoutMode = useLayoutMode();

  useEffect(() => {
    return () => {
      closeModal();
    };
  }, [closeModal]);

  if (layoutMode === 'kiosko') {
    return null;
  }

  return (
    <>
      <ShareBtnContainer onClick={openModal} className="chekin-boxes__tasks-share-btn">
        <CornerUpRight size={20} color={getMainColor(theme)} />
        <ShareText>{t('share')}</ShareText>
      </ShareBtnContainer>
      <ModalSheet
        isOpenModalSheet={isModalOpen}
        handleCloseModal={closeModal}
        maxWidth={'375px'}
        withCloseButton
      >
        <ShareRegistrationLink />
      </ModalSheet>
    </>
  );
}

export {ShareButton};
